module.exports = __webpack_public_path__ + "static/media/logo_bluefill_whiteborders_80.f1191a67.svg";